interface ErrorEntry {
  message: string;
  stack?: string;
  timestamp: string;
  url: string;
  component?: string;
  extra?: Record<string, string>;
}

const buffer: ErrorEntry[] = [];
let flushTimer: ReturnType<typeof setTimeout> | null = null;

function scheduleFlush() {
  if (flushTimer) return;
  flushTimer = setTimeout(() => {
    flushTimer = null;
    flushErrors();
  }, 30_000);
}

async function flushErrors() {
  if (buffer.length === 0) return;
  const batch = buffer.splice(0);
  try {
    await fetch('/api/telemetry/errors', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ errors: batch }),
    });
  } catch {
    // Silent — never create error reporting loops
  }
}

export function reportError(error: Error, context?: Record<string, string>) {
  buffer.push({
    message: error.message,
    stack: error.stack,
    timestamp: new Date().toISOString(),
    url: window.location.href,
    ...context,
  });

  if (buffer.length >= 10) {
    flushErrors();
  } else {
    scheduleFlush();
  }
}

export function reportPerf(name: string, durationMs: number, extra?: Record<string, string>) {
  fetch('/api/telemetry/perf', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, durationMs, url: window.location.href, timestamp: new Date().toISOString(), ...extra }),
  }).catch(() => {});
}

/**
 * Install global error handlers. Call once at app startup.
 */
export function installGlobalErrorHandlers() {
  window.onerror = (_msg, _source, _line, _col, error) => {
    if (error) reportError(error, { source: 'window.onerror' });
  };

  window.onunhandledrejection = (event: PromiseRejectionEvent) => {
    const error = event.reason instanceof Error
      ? event.reason
      : new Error(String(event.reason));
    reportError(error, { source: 'unhandledrejection' });
  };

  // Flush on page unload
  window.addEventListener('beforeunload', () => flushErrors());
}
